import { FileText, IdCard, Smartphone } from "lucide-react";
import { QrTesta } from "./QrTesta";

interface Props {
  agenzia: string;
  onAvanti: () => void;
}

/** Prima schermata del percorso cliente (spec §8 "Ingresso"). */
export function QrIngresso({ agenzia, onAvanti }: Props) {
  return (
    <div className="min-h-dvh flex flex-col bg-surface">
      <QrTesta agenzia={agenzia} />
      <div className="p-6 flex-1 flex flex-col w-full max-w-md mx-auto">
        <h1 className="font-heading text-3xl font-bold leading-tight">Cambio fornitore luce e gas</h1>
        <p className="text-lg mt-3">Le servono:</p>
        <ul className="mt-3 space-y-3 text-lg">
          <li className="flex gap-3 items-center bg-card border border-border rounded-xl p-3">
            <FileText className="w-6 h-6 text-brand shrink-0" aria-hidden="true" />
            La bolletta più recente
          </li>
          <li className="flex gap-3 items-center bg-card border border-border rounded-xl p-3">
            <IdCard className="w-6 h-6 text-brand shrink-0" aria-hidden="true" />
            Un documento d&apos;identità
          </li>
          <li className="flex gap-3 items-center bg-card border border-border rounded-xl p-3">
            <Smartphone className="w-6 h-6 text-brand shrink-0" aria-hidden="true" />
            Il suo cellulare
          </li>
        </ul>
        <p className="text-lg text-muted-foreground mt-4">Se ha dubbi, può chiedere al banco in qualsiasi momento.</p>
        <button
          type="button"
          onClick={onAvanti}
          className="mt-auto h-14 rounded-xl bg-brand text-white text-lg font-semibold"
        >
          Avanti
        </button>
      </div>
    </div>
  );
}
